import { render, staticRenderFns } from "./ProjectDetailCrew.vue?vue&type=template&id=62727bd9&scoped=true"
import script from "./ProjectDetailCrew.vue?vue&type=script&lang=js"
export * from "./ProjectDetailCrew.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailCrew.vue?vue&type=style&index=0&id=62727bd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62727bd9",
  null
  
)

export default component.exports